import { render, staticRenderFns } from "./FacturePayer.vue?vue&type=template&id=0ab40f31&"
import script from "./FacturePayer.vue?vue&type=script&lang=js&"
export * from "./FacturePayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports